/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'hero-1': {
    width: 37,
    height: 36,
    viewBox: '0 0 37 36',
    data: `<desc>Created using Figma</desc><use xlink:href="#svgicon-hero-1-a" transform="matrix(0 -1 1 0 .997 36)" fill="#F4D68A"/><defs><path pid="0" id="svgicon-hero-1-a" d="M0 0c19.882 0 36 16.118 36 36H17.38c0-9.598-7.782-17.38-17.38-17.38V0z"/></defs>`
  }
})
